export default __webpack_public_path__ + "static/media/checkmark.a8306889.png";